export const defaultAppConfig = {
  app_name: "TweetCraft AI",
  app_description: "TweetCraft AI empowers social media managers, marketers, founders, content creators, and individuals to generate on-brand, high-quality tweets in seconds. Customize topic, tone, audience, keywords, and length to produce Twitter-ready messages under 280 characters, all saved in a private, searchable history with seamless export options.",
  app_tagline: "Craft Perfect Tweets in Seconds",
  production: process.env.NODE_ENV === "production",
  app_url: process.env.APP_URL || "",
  app_id: process.env.APP_ID || "",
  
  app_logo_url_light:
    "https://app-assets.constructr.ai/97ba9f20-ba41-4d3c-8c86-47b5a82847ea/branding/logo-light.png",
  app_logo_url_dark:
    "https://app-assets.constructr.ai/97ba9f20-ba41-4d3c-8c86-47b5a82847ea/branding/logo-dark.png",

  app_full_logo_url_light:
    "https://app-assets.constructr.ai/97ba9f20-ba41-4d3c-8c86-47b5a82847ea/branding/logo-full-light.png",
  app_full_logo_url_dark:
    "https://app-assets.constructr.ai/97ba9f20-ba41-4d3c-8c86-47b5a82847ea/branding/logo-full-dark.png",

  app_badge_show: true,
  app_badge_href: "https://constructr.ai?utm_source=badge&utm_campaign=badge",
  app_badge_src: "https://assets.constructr.ai/images/made-with-badge.png",
  app_badge_alt: "Made with Constructr",
  allow_remix: false
};



